//先引入mockjs模块
import Mock from 'mockjs'
// 引入你编写json所在文件的路径
import list from "./list.json"
// 引入你编写json所在文件的路径
import tree from "./tree.json"
import tabslist from "./tabs.json"//京东数科-企业主贷
import tabslistgf from "./tabsgf.json"//广发银行-小微E秒贷
import tabslistyh from "./tabsyh.json"//邮惠万家-优商贷
import tabslistzd from "./tabszd.json"//渣打银行-逸商贷

// 模拟数据返回
Mock.mock("/mock/list", {
  code: 200,
  data: list
})
// 模拟数据返回
Mock.mock("/mock/tree", {
  code: 200,
  data: tree
})
//
Mock.mock("/mock/tabse", {
  code: 200,
  data: tabslist
})
Mock.mock("/mock/tabsgf", {
  code: 200,
  data: tabslistgf
})
Mock.mock("/mock/tabseyh", {
  code: 200,
  data: tabslistyh
})
Mock.mock("/mock/tabsezd", {
  code: 200,
  data: tabslistzd
})




// WEBPACK FOOTER //
// ./src/mock/mockServe.js